import React, { useState, useEffect } from "react";
import axios from "axios";
import { Link } from "react-router-dom";

export default function Support() {
  useEffect(() => {
    document.title = "Support | KlonIT Web Application";
  }, []);

  return (
    <div>
      <main className="content">
        <div className="container-fluid p-0">
          <div className="mb-3">
            <h1 className="h3 d-inline align-middle">
              <strong>Support</strong>
            </h1>
          </div>
          <div className="row">
            <div className="col-12 col-lg-12">
              <div className="card">
                <div className="card-body">
                  <div className="page-Dashboard">
                    <section className="section-Dashboard">
                      <div className="">
                        <div className="row">
                          <div className="col-md-12 col-lg-12 col-xl-12 website-list-group">
                            <div className="list-group">
                                <div className="row g-0 align-items-center">                                  
                                  <div className="col-12 ps-2">
                                    <div className="text-dark">Email:</div>
                                    <div className="text-muted mt-1">
                                        Support@klonit.net
                                    </div>                                    
                                  </div>
                                  <div className="col-12 ps-2">
                                    <div className="text-dark">Phone:</div>
                                    <div className="text-muted mt-1">
                                        001 123 456 789
                                    </div>                                    
                                  </div>
                                </div>
                            </div>                            
                          </div>
                        </div>
                      </div>
                    </section>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
}
